import React from "react";

import asIcon from "./asIcon";

export default asIcon(() =>
  (<g>
    <circle cx="50" cy="50" r="50" fill="#DB4A49" />
    <path fill="#FFF" d="M68.3 30H75v13.3H25V30h6.7v3.4c0 1.8 1.5 3.3 3.3 3.3 1.8 0 3.3-1.5 3.3-3.3V30h23.6v3.4c0 1.8 1.5 3.3 3.3 3.3 1.8 0 3.3-1.5 3.3-3.3V30zM25 46.7h10v10H25v-10zm13.3 0h10v10h-10v-10zm13.4 0h10v10h-10v-10zm13.3 0h10v10H65v-10zM65 60h10v10H65V60zm-40 0h10v10H25V60zm13.3 0h10v10h-10V60zm13.4 0h10v10h-10V60z" />
  </g>));
